import CognitoUserDetail from './abstract/CognitoUserDetail'
import Config from '../../../Config'
import Window from '../../../common/Window'

class CompanyUserDetail extends CognitoUserDetail {
  constructor (props) {
    super(props)
    this.state = {userDetail: '', temporaryPassword: '', isInheritingModalOpen: false, inheritingMessage: ''}
    this.apiUrl = Config.companyAdminApiUrl.companyUser
    this.nameTitle = 'ユーザ名'
    this.userRoleName = 'ユーザ'
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'

    // toggleInheritingModal の this をバインド
    this.toggleInheritingModal = this.toggleInheritingModal.bind(this)
  }
  componentWillMount () {
    const {params} = this.props.match
    const id = params.id
    this.loadUserDetail(id)
  }
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const temporaryPassword = queryParams.get('temporaryPassword');
    
    if (temporaryPassword) {
      this.setState({ temporaryPassword });
    }
  }
  toggleInheritingModal() {
    this.setState((prevState) => ({
      isInheritingModalOpen: !prevState.isInheritingModalOpen
    }))
  }
  onInheritingButtonClicked (action, e) {
    e.preventDefault()
    switch (action) {
      case 'save' :
        this.inheritingEstimation(this.state.email)
        break
      case 'cancel' :
        this.setState({ isInheritingModalOpen: false, email: '', saveMessage: '', inheritingMessage: '' })
        break
      default:
        break
    }
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  onPageMenuClicked (name) {
    const id = this.state.userDetail.id
    switch (name) {
      case 'back':
        this.props.history.push('/company_admin/' + this.userRoleUrl)
        break
      case 'edit':
        this.props.history.push('/company_admin/' + this.userRoleUrl + '/edit/' + id)
        break
      case 'sendPasswordResetEmail':
        this.props.history.push('/company_admin/' + this.userRoleUrl + '/password_change/' + id)
        break
      case 'ban':
        Window.confirm('本当に削除処理を実行しますか?', () => {
          this.deleteCognitoUser(this.state.userDetail)
          Window.alert('削除処理を実行しました', () => {
            this.props.history.push('/company_admin/' + this.userRoleUrl)
            Window.closeDialog()
          })
        })
        break
      case 'disable':
        Window.confirm('本当に一時無効処理を実行しますか?', () => {
          this.disableCognitoUser(this.state.userDetail)
          Window.alert('一時無効処理を実行しました', () => {
            const userDetail = this.state.userDetail
            userDetail.enabled = false
            this.setState({
              userDetail: userDetail
            })
            Window.closeDialog()
          })
        })
        break
      case 'enable':
        Window.confirm('本当に復活処理を実行しますか?', () => {
          this.enableCognitoUser(this.state.userDetail)
          Window.alert('復活処理を実行しました', () => {
            const userDetail = this.state.userDetail
            userDetail.enabled = true
            this.setState({
              userDetail: userDetail
            })
            Window.closeDialog()
          })
        })
        break
      default:
        break
    }
  }
}

export default CompanyUserDetail



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/CompanyUserDetail.js